import o from "./lib/axios.js";
const {
  Axios: e,
  AxiosError: a,
  CanceledError: s,
  isCancel: t,
  CancelToken: i,
  VERSION: l,
  all: n,
  Cancel: d,
  isAxiosError: x,
  spread: C,
  toFormData: c,
  AxiosHeaders: m,
  HttpStatusCode: p,
  formToJSON: A,
  getAdapter: f,
  mergeConfig: E
} = o;
export {
  e as Axios,
  a as AxiosError,
  m as AxiosHeaders,
  d as Cancel,
  i as CancelToken,
  s as CanceledError,
  p as HttpStatusCode,
  l as VERSION,
  n as all,
  o as default,
  A as formToJSON,
  f as getAdapter,
  x as isAxiosError,
  t as isCancel,
  E as mergeConfig,
  C as spread,
  c as toFormData
};
